import { UserProvider } from "./auth";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { FeaturesProvider } from "./hooks/FeaturesProvider";
import { ThemeProvider } from "styled-components";
import getTheme from "./theme";
import { CalendarSelector } from "./pages/Calendar";
import GlobalStyle from "./components/GlobalStyle";
import AuthenticatedRoute from "./auth/AuthenticatedRoute";
import LoginPage from "./pages/Login";
import Logout from "./pages/Logout";
import Insights from "./pages/Insights";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import SettingsPage from "./pages/Settings";
import { SettingsProvider, useSettings } from "./Settings";
import Subscribe from "./pages/Subscribe";
import Success from "./pages/Subscribe/Success";
import { SubscriptionProvider, useSubscription } from "./auth/Subscription";
import NotFound from "./pages/NotFound";
import ConfirmEmail from "./pages/ConfirmEmail";
import AdminDashboard from "./pages/Admin";
import { BrushesProvider } from "hooks/BrushesProvider";
import { LoginWithNonce } from "pages/Login/Nonce";

const Routing = () => {
  return (
    <Router>
      <Switch>
        <Route
          path={[
            "/login",
            "/signup",
            "/forgot-password",
            "/reset-password/:code",
          ]}
          exact
          component={LoginPage}
        />
        <Route path="/login-nnc" exact component={LoginWithNonce} />
        <Route path="/privacy-policy" exact component={PrivacyPolicy} />
        <Route path="/confirm-email/:code" exact component={ConfirmEmail} />
        <AuthenticatedRoute path="/logout" exact component={Logout} />
        <AuthenticatedRoute
          path="/schedule"
          exact
          component={CalendarSelector}
        />
        <Redirect path="/report" exact to="/insights" />
        <AuthenticatedRoute path="/insights" exact component={Insights} />
        <AuthenticatedRoute path="/settings" component={SettingsPage} />
        <AuthenticatedRoute path="/subscribe" exact component={Subscribe} />
        <AuthenticatedRoute
          path="/admin-dashboard"
          exact
          component={AdminDashboard}
        />
        <AuthenticatedRoute
          path="/subscribe/success"
          exact
          component={Success}
        />
        <Redirect path="/calendar" to="/schedule" />
        <Redirect path="/" exact to="/schedule" />
        <Route component={NotFound} />
      </Switch>
    </Router>
  );
};

const App = () => (
  <>
    <GlobalStyle />
    <Routing />
  </>
);

const Providers = ({ children }) => {
  return (
    <UserProvider>
      <SettingsProvider>
        <SubscriptionProvider>
          <FeaturesProvider>
            <UserThemeProvider>
              <BrushesProvider>{children}</BrushesProvider>
            </UserThemeProvider>
          </FeaturesProvider>
        </SubscriptionProvider>
      </SettingsProvider>
    </UserProvider>
  );
};

const UserThemeProvider = ({ children }) => {
  const [settings] = useSettings();
  const [subscription] = useSubscription();
  return (
    <ThemeProvider theme={getTheme(settings, subscription)}>
      {children}
    </ThemeProvider>
  );
};

const Root = () => (
  <Providers>
    <App />
  </Providers>
);

export default Root;
